import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { css, up, styled } from '@smooth-ui/core-sc';
import { Link } from 'react-router-dom';
import { trailingSlashIt } from '_platform/src/utils/utilities';

import { withSettings } from 'containers/WebApp/SettingsContext';
import Logos from './images/JA_Logos_white.png';

const FooterWrapper = styled.footer`
  background-color: #192170;
  z-index: 1;
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 0.5rem 1rem 1rem;

  div,
  p {
    text-align: center;
  }

  img {
    padding: 1rem 0;
  }

  p {
    color: #fff;
    margin: 0;
    padding: 0.6rem 0;
    line-height: 0.8;
  }

  a {
    color: #fff;
    text-decoration: none;
    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  ul {
    margin: 1rem 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${up(
      'md',
      css`
        flex-direction: row;
      `
    )};
  }
  li {
    font-size: 12px;
    color: #fff;
    text-align: center;
    padding: 2px 0;
    line-height: 1.2;
    ${up(
      'md',
      css`
        border-right: 1px solid #fff;
        padding: inherit;
        text-align: left;
        &:nth-last-child(1) {
          border-right: none;
        }
        &:first-child {
          padding-left: 0;
          margin-left: 0;
        }
      `
    )};

    a {
      padding: 0 0.5rem;
    }
  }
`;

const Footer = ({ siteName, location }) => (
  <FooterWrapper>
    <FooterContainer>
      <div>
        <a
          href="https://www.jarussell.co.nz"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={Logos} alt="J.A. Russell" width={300} />
        </a>
      </div>

      <p>
        &copy; {new Date().getFullYear()} All rights reserved. J. A. Russell Ltd
      </p>

      {trailingSlashIt(location.pathname) !== '/login/' &&
        trailingSlashIt(location.pathname) !== '/password-reset/' && (
          <ul>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms">Terms &amp; Conditions</Link>
            </li>
          </ul>
        )}
      <p className="text--small">
        Powered by Lori from{' '}
        <a
          href="https://212f.com/nz/business-analytics/"
          target="_blank"
          rel="noopener noreferrer"
        >
          212&deg;f Labs
        </a>
      </p>
    </FooterContainer>
  </FooterWrapper>
);

Footer.propTypes = {
  siteName: PropTypes.string,
  location: PropTypes.object.isRequired,
};

Footer.defaultProps = {
  siteName: 'Lori Program Default',
};

export default withSettings(Footer);
